import React from 'react';
import { Navigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/free-solid-svg-icons';
import { useAuth } from '../context/AuthContext';

interface AdminRouteProps {
  children: React.ReactNode;
}

const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="gp-page flex items-center justify-center">
        <div className="text-center">
          <div className="gp-spinner mb-3" role="status" aria-label="Loading" />
          <p className="gp-text-muted text-sm">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!user.isAdmin) {
    return (
      <div className="gp-page flex items-center justify-center">
        <div className="text-center px-4">
          <div
            className="w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-3"
            style={{ background: 'var(--gp-accent-soft)', color: 'var(--gp-accent)' }}
          >
            <FontAwesomeIcon icon={faLock} className="text-xl" />
          </div>
          <h2 className="font-display text-lg font-semibold mb-1" style={{ color: 'var(--gp-ink)' }}>
            Access Denied
          </h2>
          <p className="gp-text-muted text-sm mb-4">
            You need admin privileges to access this page.
          </p>
          <a href="/dashboard" className="gp-back-link">
            Return to Dashboard
          </a>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default AdminRoute;
